import React, { Fragment, useState, useEffect } from 'react';
import Header from '../../components/header/Header';
import Footer from '../../components/footer/Footer';
import Scrollbar from '../../components/scrollbar/scrollbar';
import '../../css/presale.css';
import '../../css/token.css'; 
import TurtleWalletButton from '../../components/TurtleButton/TurtleWalletButton';
import cartoonLeft from '../../images/shapes/shape_pepetheog.png';
import cartoonRight from '../../images/shapes/shape_cartoon_10.webp';

const TokenPage = () => {
  const [selectedCurrency, setSelectedCurrency] = useState('ETH');
  const [amount, setAmount] = useState('');
  const [pepeAmount, setPepeAmount] = useState(0);
  const [exchangeRates, setExchangeRates] = useState({ ETH: 0, USDT: 0, BNB: 0 });
  const [pepePriceInUsd, setPepePriceInUsd] = useState(0);
  const [timeLeft, setTimeLeft] = useState({});

  useEffect(() => {
    const fetchRates = async () => {
      try {
        const res = await fetch(
          'https://api.coingecko.com/api/v3/simple/price?ids=ethereum,binancecoin,tether,pepe&vs_currencies=usd'
        );
        const data = await res.json();
        setExchangeRates({
          ETH: data.ethereum.usd,
          USDT: data.tether.usd,
          BNB: data.binancecoin.usd,
        });
        setPepePriceInUsd(data.pepe.usd);
      } catch (error) {
        console.error('Error fetching exchange rates:', error);
      }
    };

    fetchRates();
    const timer = setInterval(fetchRates, 30000);
    return () => clearInterval(timer);
  }, []);

  useEffect(() => {
    const endTime = new Date('2025-06-30T23:59:59Z').getTime();
    const updateCountdown = () => {
      const now = Date.now();
      const diff = endTime - now;
      if (diff <= 0) {
        setTimeLeft({ expired: true });
        return;
      }
      setTimeLeft({
        days: Math.floor(diff / (1000 * 60 * 60 * 24)),
        hours: Math.floor((diff / (1000 * 60 * 60)) % 24),
        minutes: Math.floor((diff / (1000 * 60)) % 60),
        seconds: Math.floor((diff / 1000) % 60),
      });
    };

    updateCountdown();
    const interval = setInterval(updateCountdown, 1000);
    return () => clearInterval(interval);
  }, []);

  const handleAmountChange = (e) => {
    const val = e.target.value;
    if (!/^\d*\.?\d*$/.test(val)) return;
    setAmount(val);
    const rate = exchangeRates[selectedCurrency] || 0;
    const usdVal = parseFloat(val || 0) * rate;
    const pepe = usdVal / (pepePriceInUsd || 1);
    setPepeAmount(isNaN(pepe) ? 0 : pepe.toFixed(2));
  };

  const handleCurrencyChange = (curr) => {
    setSelectedCurrency(curr);
    setAmount('');
    setPepeAmount(0);
  };

  return (
    <Fragment>
      <div className="index_pepecoin page_wrapper">
         {/* Left Cartoon */}
        <img src={cartoonLeft} alt="Decoration Left" className="cartoon-shape-left" />

        {/* Right Cartoon */}
        <img src={cartoonRight} alt="Decoration Right" className="cartoon-shape-right" />
        <Header />
        <main className="page_content">
          <div className="token-page-main">
            <div className="presale_card">
              <div className="presale-header">
                <h1 className="presale-title">PRESALE IS LIVE</h1>
                {timeLeft.expired ? (
                  <p className="expired-text">Presale Ended</p>
                ) : (
                  <div className="countdown-text">
                    Ends in: {timeLeft.days}d : {timeLeft.hours}h : {timeLeft.minutes}m : {timeLeft.seconds}s
                  </div>
                )}
                <p className="amount-raised">$0.00 <span>RAISED</span></p>
              </div>

              <div className="progress-bar-container">
                <div className="progress-indicator">
                  <div className="progress-dot">
                    <div className="progress-dot-inner" />
                  </div>
                </div>
              </div>

              <div className="stats-row">
                <div>
                  <p className="stat-label">Current Price</p>
                  <p className="stat-value">${pepePriceInUsd?.toFixed(8) ?? '––'}</p>
                </div>
                <div>
                  <p className="stat-label">Stage</p>
                  <p className="stat-value">2</p>
                </div>
                <div>
                  <p className="stat-label">Price at Launch</p>
                  <p className="stat-value">$0.002</p>
                </div>
              </div>

              <div className="live-rates">
                Live Rates — 1 ETH = ${exchangeRates.ETH?.toFixed(2)} | 1 BNB = ${exchangeRates.BNB?.toFixed(2)} | 1 USDT = ${exchangeRates.USDT?.toFixed(2)} | 1 PEPE = ${pepePriceInUsd?.toFixed(8)}
              </div>

              <div className="currency-buttons">
                {['ETH', 'USDT', 'BNB'].map((currency) => (
                  <button
                    key={currency}
                    className={`currency-button ${selectedCurrency === currency ? 'active' : ''}`}
                    onClick={() => handleCurrencyChange(currency)}
                  >
                    {currency}
                  </button>
                ))}
              </div>

              <div className="conversion-inputs">
                <div className="input-field-container">
                  <p className="input-label">You Pay</p>
                  <div className="input-content">
                    <input
                      type="text"
                      placeholder="Enter Amount"
                      value={amount}
                      onChange={handleAmountChange}
                    />
                    <span>{selectedCurrency}</span>
                  </div>
                </div>
                <div className="input-field-container">
                  <p className="input-label">You Receive</p>
                  <div className="input-content">
                    <span>{pepeAmount}</span>
                    <span>$PEPE</span>
                  </div>
                </div>
              </div>

              <div className="wallet-buttons">
  <TurtleWalletButton title="BONUS CODE" />
  <TurtleWalletButton title="REFERRAL PROGRAM" />
</div>

<div className="wallet-connect-main">
  <TurtleWalletButton
    title="CONNECT WALLET"
    fontSize="1.5rem"
    padding="1rem 3rem"
    marginTop="2rem"
  />
</div>

            </div>
          </div>
          <Scrollbar />
        </main>
        <Footer />
      </div>
    </Fragment>
  );
};

export default TokenPage;
